import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {RawPagedCollectionResponse, RawPerson} from '../types'

export interface ListPersonsRequest {
  ClientID: number
  IDs: number[]
  PageNumber: number
  PageSize: number
  IncludeContactDetails?: boolean
}

export interface ListPersons<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const list: ListPersons<
  ListPersonsRequest,
  RawPagedCollectionResponse<RawPerson>
> = (http, params) => {
  const {ClientID, IDs, PageNumber, PageSize, IncludeContactDetails} = params

  const queryParams: string[] = []
  queryParams.push(`clientid=${ClientID}`)
  queryParams.push(`pagenumber=${PageNumber}`)
  queryParams.push(`pagesize=${PageSize}`)
  if (IncludeContactDetails !== undefined) {
    queryParams.push(`includecontactdetails=${IncludeContactDetails}`)
  }
  IDs.forEach((id) => queryParams.push(`id=${id}`))
  const query = `?${queryParams.join('&')}`

  return http.request<RawPagedCollectionResponse<RawPerson>>({
    method: 'GET',
    url: `/v1/persons${query}`,
    headers: {Release: 'Beta'},
  })
}
